import produce from 'immer'

const initialState = {
  clientId: '',
}

export default (state = initialState, { type, payload }) =>
  produce(state, draft => {
    const newDraft = draft

    switch (type) {
      case '@azure/SET_CLIENT_ID': {
        newDraft.clientId = payload.clientId
        break
      }
      default:
    }
  })
